module.exports = "<h1 id=\"9-元素变化--属性変化\">9. 元素变化 / 属性変化</h1>\n<p><strong><code>ElementChange</code>。</strong>元素变化出现在部分敌人身上，可以改变自身的元素。</p>\n";